// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-emphasize[data-v-c566d8da] {\n  background-color: #9055cb;\n}\n.bg-emphasize[data-v-c566d8da]:hover {\n  background-color: #683c93;\n}\n.bg-emphasize[data-v-c566d8da]:focus {\n  background-color: #683c93;\n}\n.bg-emphasizeblue[data-v-c566d8da] {\n  background-color: #1A7BEE;\n}\n.bg-emphasizegreen[data-v-c566d8da] {\n  background-color: #32ECD6;\n}\n.bg-emphasizegray[data-v-c566d8da] {\n  background-color: #EAEAEA;\n}", ""]);
// Exports
module.exports = exports;
